import HttpClient from "../../clients/HttpClient";
import MobilityContractPayoutConfig from "../../models/MobilityContractPayoutConfig";

export default class MobilityContractPayoutConfigsService {
    static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

    public static async list(params = {}): Promise<Array<MobilityContractPayoutConfig>> {
        return this.httpClient.get("/mobility_contract_payout_configs", params).then((res) => {
            return res.data.map((row) => new MobilityContractPayoutConfig(row));
        });
    }

    public static async getMobilityContractPayoutConfig(id): Promise<MobilityContractPayoutConfig> {
        return this.httpClient.get(`/mobility_contract_payout_configs/${id}`).then((res) => {
            return new MobilityContractPayoutConfig(res.data);
        });
    }

    public static async listOnAccount(accountId): Promise<Array<MobilityContractPayoutConfig>> {
        return this.httpClient.get("/accounts/" + accountId + "/mobility_contract_payout_configs").then((res) => {
            return res.data.map((row) => new MobilityContractPayoutConfig(row));
        });
    }

    public static async addMobilityContractPayoutConfig(data: MobilityContractPayoutConfig): Promise<MobilityContractPayoutConfig> {
        const payload = {
            ...data,
            maxMobilityContractPayoutsPerApartment: Number.parseInt(`${data.maxMobilityContractPayoutsPerApartment}`),
            walletPayoutAmountCents: Number.parseInt(`${data.walletPayoutAmountCents}`),
            walletPayoutMessage: JSON.stringify(data.walletPayoutMessage ?? {}),
        };

        return this.httpClient.post(`/mobility_contract_payout_configs`, payload).then((res) => {
            return new MobilityContractPayoutConfig(res.data);
        });
    }

    public static async editMobilityContractPayoutConfig(id, data): Promise<MobilityContractPayoutConfig> {
        const payload = {
            ...data,
            id: id,
            maxMobilityContractPayoutsPerApartment: Number.parseInt(`${data.maxMobilityContractPayoutsPerApartment}`),
            walletPayoutAmountCents: Number.parseInt(`${data.walletPayoutAmountCents}`),
            walletPayoutMessage: JSON.stringify(data.walletPayoutMessage ?? {}),
        };

        return this.httpClient.put(`/mobility_contract_payout_configs`, payload).then((res) => {
            return new MobilityContractPayoutConfig(res.data);
        });
    }

    public static async deleteMobilityContractPayoutConfig(id): Promise<boolean> {
        return this.httpClient.delete(`/mobility_contract_payout_configs/${id}`, null).then((res) => {
            return true;
        });
    }
}


